import type { CodemodOrder } from '@design-system/migration-utils';

import {
  renameAppHeaderDeprecatedMembersMotion,
  renameAppHeaderDeprecatedMembersCodemod,
} from './codemods/rename-app-header-deprecated-members.js';

export const codemodOrder: CodemodOrder = [
  {
    description: 'rename deprecated AppHeader sub-components',
    motion: renameAppHeaderDeprecatedMembersMotion,
    codemod: renameAppHeaderDeprecatedMembersCodemod,
  },
];
